
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PageFooter',
  setup() {
    return {}
  }
})
